import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-view-pdf",
  templateUrl: "./view-image.component.html",
})
export class ViewImageComponent implements OnInit {
  activeLang: string = "en";
  constructor(
    public dialogRef: MatDialogRef<ViewImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log("daatdstadtaasdasd", this.data);
  }

  ngOnInit(): void {}
}
